// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-verification__error[data-v-57eb142e] {\n  color: var(--v-error-base);\n}", ""]);
// Exports
module.exports = exports;
